import gql from 'graphql-tag';

export const GetListTrainingQuery = gql`
query GetListTrainingQuery($TrainingType: String = ""){
  trainings (trainingtype: $TrainingType) {
    id
   name
   bottomSectionText
   pdfText
   pdfUrl
   pdfViewText
   sectionHeading
   sectionText
   sectionTitle
   trainingFile
   trainingQuizNumber
   videoAltText
   videoTeaserImage
   videoText
   watchButtonText
   videoUrl
   }
}
`;


